import React, { createContext, useContext, useState, useEffect } from 'react';
import { isAdminAuthenticated, adminLogout, getAdminToken } from '../utils/adminApi';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const authenticated = isAdminAuthenticated();
    setIsAuthenticated(authenticated);
    if (authenticated) {
      setToken(getAdminToken());
    }
    setLoading(false);
  }, []);

  const login = () => {
    setIsAuthenticated(true);
    setToken(getAdminToken());
  };

  const logout = () => {
    adminLogout();
    setIsAuthenticated(false);
    setToken(null);
  };

  const value = {
    isAuthenticated,
    loading,
    login,
    logout,
    token,
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};
